<template>
<!-- eslint-disable max-len -->
<div v-if="ageGroups.length === 0 || (selectedAgeGroup && ageGroupCommitted)">
  <bottom-bar :next="navigateAndSaveSelection" style="z-index: -1 !important;">
    <span slot="button">
      <span v-html="game.avatarSelectButtonText || 'Select'"></span>
    </span>
  </bottom-bar>

  <div
    :style="`position: absolute; top: 60px; height: 100%; ${(starfighter) ? 'z-index: -10;' : ''}`"
  >
    <transition-group>
      <span
        v-for="({ key, character, player, role }, i) in rotatedAvatars"
        class="character"
        :class="{ native, 'rotate-move': shouldMove(i), 'character-selected': (i === avatarCount), }"
        :key="key"
        :style="{
          left: `${slotPosition(i)}px`,
          opacity: !(shouldMove(i)) ? 0 : (player || role ? 0.25 : 1),
        }"
      >
        <transition v-if="character != null" name="fade" enter-active-class="animated fadeIn" mode="out-in">
          <div v-if="i === avatarCount" key="selected">
            <img
              :src="resolveAssetPath(character.imageSelected, 'characters')"
              class="avatar-selected"
              :class="{ 'sf' : (starfighter), native }">
          </div>
          <div v-else key="unselected">
            <img
              :src="resolveAssetPath(character.imageUnselected, 'characters')"
              class="avatar-unselected"
              :class="{ 'sf' : (starfighter), native }">
          </div>
        </transition>
        <div
          style="position: absolute; bottom: 10%; left: 0; width: 100%; height: 90%; pointer-events: all;"
          @click="goToCharacter(i)"
        >
        </div>
        <tooltip
          v-if="i === avatarCount"
          target="selectedAvatar"
          :style="starfighter ? {
            transform: 'scale(1.15)',
            bottom: '68px',
          } : undefined"
          disable-exit-transition
        >
        </tooltip>
      </span>
    </transition-group>
  </div>

  <p v-if="false && selectedAvatarBio" class="selected-bio">{{ selectedAvatarBio }}</p>

  <button id="left-select" class="btn select left" @click="left" v-focus>
    <img :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')">
  </button>
  <div v-if="doExtraTooltipHighlightsOverArrows" class="select left" :style="tooltipHighlightStyle">
  </div>

  <button id="right-select" class="btn select right" @click="right">
    <img :src="resolveAssetPath('ArrowL_Tall.png', 'ui/customer')">
  </button>
  <div v-if="doExtraTooltipHighlightsOverArrows" class="select right" :style="tooltipHighlightStyle">
  </div>

  <top-bar style="position: relative;" :clear-background="!starfighter">
    <!--
      Never use v-html with end-user generated content, because it's a vector for XSS attacks
      This is what the following line used to be:
      <span :class="{ 'title-native' : (native) }">{{game.avatarSelectTitleText || 'SELECT YOUR CHARACTER'}}</span>
    -->
    <span :class="{ 'title-native' : (native) }" v-html="game.avatarSelectTitleText || 'SELECT YOUR CHARACTER'"></span>
    <button
      v-if="ageGroups.length !== 0 && selectedAgeGroup && ageGroupCommitted"
      class="btn"
      style="height: 50%; position: absolute; top: 25px; left: 25px; font-size: 22px; padding: 10px; z-index: 100;"
      @click.prevent.stop="() => { ageGroupCommitted = false; }"
    >
      {{game.avatarSelectGroupSelectBackButtonText || 'Change Age'}}
    </button>
  </top-bar>
</div>
<div v-else style="height: 900px;">
  <top-bar :clear-background="!starfighter">
    <!--
      Never use v-html with end-user generated content, because it's a vector for XSS attacks
    -->
    <span :class="{ 'title-native' : (native) }" v-html="game.avatarSelectGroupSelectTitleText || 'SELECT YOUR AGE'"></span>
  </top-bar>

  <div
    style="width: 105%; height: 98%; display: flex; justify-content: flex-end; align-items: center; perspective: 1px;"
  >
    <div
      style="width: 95%; height: 60%; position: relative; border: 90px solid rgba(0, 0, 0, 0); border-image: url('/static/ui/customer/B2_TextBox_90.png') 90 fill; transform: translateZ(0);"
    >
      <div style="color: black; font-size: 32px; position: absolute; top: -50px; left: 50px;">
        {{game.avatarSelectGroupSelectPromptText || 'What age would you like your character to be?'}}
      </div>
      <div
        style="margin: 15px 270px 0 0; width: 950px; height: 100%; display: flex; flex-direction: row; justify-content: space-around; align-items: center;"
      >
        <div
          v-for="({ image, label }, i) in ageGroups"
          :key="`${label}-${i}`"
          :style="`width: ${Math.round(90 / ageGroups.length)}%; display: flex; flex-direction: column; justify-content: center; align-items: center;`"
        >
          <button
            class="btn"
            @click.prevent.stop="() => { selectedAgeGroup = label; }"
          >
            <img
              :src="resolveAssetPath(image, 'ui/customer')"
              :style="`max-height: 280px; max-width: 280px; object-fit: contain; transition: all 0.25s ease-in-out; ${(selectedAgeGroup === label) ? 'border: 15px solid var(--primaryColor);' : 'border: none;'}`"
            >
          </button>
          <div style="color: black; font-size: 30px;">
            {{label}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- TODO: make this more configurable? -->
  <narrator
    v-if="ageGroups.length !== 0 && (!selectedAgeGroup || !ageGroupCommitted)"
    style="pointer-events: none;"
  >
  </narrator>

  <!-- TODO: aren't the v-ifs on these redundant? -->
  <bottom-bar
    v-if="ageGroups.length !== 0 && (!selectedAgeGroup || !ageGroupCommitted)"
    :next="!selectedAgeGroup ? undefined : () => { ageGroupCommitted = true; }"
    no-focus
    style="z-index: 100 !important;"
  >
    <span slot="button">
      <span v-html="game.avatarSelectButtonText || 'Select'"></span>
    </span>
  </bottom-bar>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import TopBar from '../ui/TopBar';
import BottomBar from '../ui/BottomBar';
import Narrator from '../ui/Narrator';
import Tooltip from '../ui/Tooltip';

export default {
  components: {
    TopBar,
    BottomBar,
    Narrator,
    Tooltip,
  },
  data() {
    return {
      displayedSelectedAvatarIndex: 0,
      selectedAvatarIndex: 0,
      enableMove: true,
      submitting: false,
      updating: false,
      errorCount: 0,
      maxErrors: 3,
      selectedAgeGroup: '',
      ageGroupCommitted: false,
      intervalID: null,
      failCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      'avatarSelectBackground',
      'tooltip',
      'group',
      'updateGroup',
      'ageGroups',
      'avatarsByAgeGroup',
      'game',
      'starfighter',
      'native'
    ]),
    avatarCount() {
      return this.avatars.length;
    },
    keyedAvatars() {
      return [
        ...this.avatars.map((avatar, i) => ({ key: i, ...avatar })),
        ...this.avatars.map((avatar, i) => ({ key: this.avatarCount + i, ...avatar })),
        ...this.avatars.map((avatar, i) => ({ key: this.avatarCount * 2 + i, ...avatar })),
      ];
    },
    displayedMinIndex() {
      const unwrappedIndex = (this.displayedSelectedAvatarIndex - this.avatarCount);
      return unwrappedIndex >= 0 ? unwrappedIndex : (unwrappedIndex + this.keyedAvatars.length);
    },
    rotatedAvatars() {
      // console.log(this.keyedAvatars.slice(this.displayedMinIndex, this.keyedAvatars.length)
      //   .concat(this.keyedAvatars.slice(0, this.displayedMinIndex)));
      return this.keyedAvatars.slice(this.displayedMinIndex, this.keyedAvatars.length)
        .concat(this.keyedAvatars.slice(0, this.displayedMinIndex));
    },
    selectedAvatar() {
      return this.avatars[this.selectedAvatarIndex] || {};
    },
    selectedAvatarBio() {
      const { bio = '' } = this.selectedAvatar.character || {};
      return bio;
    },
    avatars() {
      if (this.selectedAgeGroup && this.avatarsByAgeGroup[this.selectedAgeGroup]) {
        return this.avatarsByAgeGroup[this.selectedAgeGroup];
      }
      return this.$store.getters.avatars;
    },
    visibleSlots() {
      return Math.min(5, this.avatars.length);
    },
    doExtraTooltipHighlightsOverArrows() {
      return this.tooltip && this.tooltip.target && this.tooltip.target === 'selectedAvatar';
    },
    tooltipHighlightStyle() {
      return !(this.tooltip) ? {} : {
        outline: this.tooltip.highlightBorder ? this.tooltip.highlightBorder : undefined,
        'border-radius': '5px', // matches btn
        'margin-top': '2px', // matches btn
        'background-color': this.tooltip.highlightColor || 'rgba(231, 154, 21, 0.25)',
        'pointer-events': 'none',
        'z-index': '10000',
      };
    },
  },
  methods: {
    ...mapActions([
      'playSound',
      'selectAvatar',
      'setTooltips',
      'advanceTooltip',
      'getMyGroup',
      'pollGroup'
    ]),
    slotPosition(i) {
      return ((i - this.avatarCount + (this.starfighter ? 1 : 2))
        * 1600 / this.visibleSlots + (this.starfighter ? 40 : 0));
    },
    shouldMove(i) {
      return this.enableMove
        && this.slotPosition(i) >= 0
        && this.slotPosition(i) <= 1640;
    },
    adjustSelectedCharacterIndex(by) {
      const displayLength = this.rotatedAvatars.length;
      // console.log(this.selectedAvatarIndex);
      const selectedAvatarIndex =
        (this.selectedAvatarIndex + by + this.avatarCount) % this.avatarCount;
      const displayedSelectedAvatarIndex =
        (this.displayedSelectedAvatarIndex + by) % displayLength;
      // console.log(selectedAvatarIndex);
      this.displayedSelectedAvatarIndex = displayedSelectedAvatarIndex;
      this.selectedAvatarIndex = selectedAvatarIndex;
    },
    playArrowButtonSound() {
      const sound = (this.game.avatarSelectArrowButtonSound)
        ? this.game.avatarSelectArrowButtonSound
        : this.game.arrowButtonSound;
      if (sound) {
        this.playSound({ sound });
      }
    },
    async left() {
      this.playArrowButtonSound();
      await Vue.nextTick();
      this.adjustSelectedCharacterIndex(-1);
    },
    async right() {
      this.playArrowButtonSound();
      await Vue.nextTick();
      this.adjustSelectedCharacterIndex(1);
    },
    async goToCharacter(index) {
      if (this.disableCarousel) return;
      const selectReferenceIndex = this.avatarCount;
      let adjustment = index - selectReferenceIndex;
      while (adjustment !== 0) {
        await Vue.nextTick();
        const sign = Math.sign(adjustment);
        this.adjustSelectedCharacterIndex(sign);
        adjustment -= sign;
        await new Promise(resolve => setTimeout(resolve, 45));
      }
    },
    async navigateAndSaveSelection() {
      if (this.submitting || this.updating) return;

      this.playClick();

      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }

      const { character: avatar, player, role } = this.selectedAvatar;
      if (player || role) return;

      try {
        this.submitting = true;
        await this.selectAvatar({ avatar });
        this.$router.nextGameState();
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.errorCount += 1;
        if (this.errorCount >= this.maxErrors) return this.$router.showGameErrorCritical();
        // TODO: flash message ?
        this.submitting = false;
      }
    },
    playClick() {
      this.playSound({ sound: this.game.clickSoundOverride || this.resolveAssetPath('click_cut.mp3', 'ui/customer') });
    },
    async poll() {
      try {
        // TODO: should use the updating flag here when triggered by peerjs
        // this.updating = true;
        await this.pollGroup();
        this.failCount = 0;
        // this.updating = false;
      } catch (err) {
        // this.updating = false;
        this.failCount += 1;
        if (this.failCount > 3) {
          if (await this.$router.handleGameError(err)) return;
          this.$router.showGameErrorCritical();
        }
      }
    }
  },
  watch: {
    async updateGroup(newValue) {
      if (!newValue) return;

      try {
        this.updating = true;
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
        this.updating = false;
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    }
  },
  async created() {
    if (this.avatars.length < 2) {
      try {
        const { character: avatar } = this.selectedAvatar;
        await this.selectAvatar({ avatar });
        this.$router.nextGameState();
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    }
  },
  async mounted() {
    if (this.group.players.length > 1) {
      this.intervalID = window.setInterval(this.poll, 5000);
    }
    if (this.game.avatarSelectTooltips && this.game.avatarSelectTooltips.length) {
      this.setTooltips({ tooltips: this.game.avatarSelectTooltips });
      await new Promise(resolve => setTimeout(resolve, 50));
      this.advanceTooltip(); // show first tooltip
    }
  },
  beforeDestroy() {
    if (this.intervalID != null) {
      window.clearInterval(this.intervalID);
    }
    this.setTooltips({ tooltips: [] });
  }
};
</script>

<style lang="scss" scoped>
.title-native {
  font-size: 42px;
  vertical-align: top;
}
.fadeIn {
  animation-duration: 0.0s;
}
#narrator-bubble {
  top: 180px;
  left: 210px;
}
.character {
  position: absolute;
  bottom: 90px;
}
.character-selected {
  z-index: 10;
}
.character.native {
  top: 0;
  bottom: unset;
  pointer-events: none;
}
.character img {
  transform-origin: bottom center;
  transition: none;
}
img.avatar-selected.sf {
  position: relative;
  bottom: 40px;
  transform: scale(1.15);
}
img.avatar-unselected.sf {
  transform: scale(1.25);
}
img.avatar-selected.native {
  // display: inline-block;
  // position: absolute;
  z-index: 100 !important;
}
.selected-bio {
  background-color: white;
  width: 505px;
  height: 200px;
  position: absolute;
  bottom: 50px;
  left: 675px;
  font-size: 32px;
  padding: 15px 25px
}
.select {
  position: absolute;
  padding: 0;
  min-width: 0;
  width: 56px;
  height: 85px;
  top: 399px;

  img {
    height: 41%;
    width: 82%;
  }
}

.select.left {
  left: 36px;
}
.select.left:focus {
  outline: none;
}
.select.right {
  right: 36px;

  img {
    transform: rotate(180deg);
  }
}
.select.right:focus {
  outline: none;
}
.rotate-move {
  transition: left 0.75s cubic-bezier(0.075, 0.82, 0.165, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/AvatarSelect.vue